import { Injectable } from '@angular/core';
import {
  MessagePosition,
  MessageType,
  SnackBarService,
} from '@epicuro-next/ataraxia/snack-bar';
import { UsersApiService } from '@epicuro-next/data/users';
import {
  getCurrentLanguage,
  languageActions,
} from '@epicuro-next/platform/i18n';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import {
  loadUserSuccess,
  setLanguagePrefrence,
  setLanguagePrefrenceFail,
} from '../actions';

@Injectable()
export class UserLanguageEffects {
  constructor(
    private actions$: Actions,
    private userService: UsersApiService,
    private snackBarService: SnackBarService,
  ) {}

  public setPrefferedLanguage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserSuccess),
      map(({ user }) => {
        const loginLanguage = localStorage.getItem('phoenix-login-language');

        return !!loginLanguage ? loginLanguage : user.preferredCultureInfo;
      }),
      map((selected) =>
        languageActions.setLanguage({
          selected: selected ?? getCurrentLanguage(),
        }),
      ),
    ),
  );

  public postLanguagePreference$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setLanguagePrefrence),
      switchMap(({ languageCode }) =>
        this.userService
          .postLanguage(languageCode)
          .pipe(map(() => languageCode)),
      ),
      map((languageCode) =>
        languageActions.setLanguage({ selected: languageCode }),
      ),
      catchError(() => of(setLanguagePrefrenceFail())),
    ),
  );

  public postLanguagePreferenceFail$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(setLanguagePrefrenceFail),
        tap(() => {
          this.snackBarService.show(
            $localize`:UserMenu@@setLanguagePreferenceFail:There was an error while changing your language. Please refresh the page and try again later.`,
            MessagePosition.BOTTOM,
            MessageType.DANGER,
          );
        }),
      ),
    { dispatch: false },
  );
}
